module.exports = __webpack_public_path__ + "static/media/direction-both.c624a235.svg";